function LockRebootModal({ open, onClose, onProceed, loading, lockDataToReboot }) {
    if (!open) return null;

    return (
        <div style={{
            position: "fixed", inset: 0, zIndex: 1500,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex", alignItems: "center", justifyContent: "center",
            padding: "20px",
        }}>
            <div style={{
                backgroundColor: "#fff", borderRadius: "16px",
                padding: "24px 20px", width: "100%", maxWidth: "420px",
                boxShadow: "0 8px 32px rgba(0,0,0,0.18)", position: "relative",
            }}>
                {/* Close */}
                <button onClick={onClose} style={{
                    position: "absolute", top: 14, right: 14,
                    background: "none", border: "none", cursor: "pointer",
                    fontSize: 20, color: "#ef4444", fontWeight: 700,
                }}
                    disabled={loading}
                >✕</button>

                {/* Title */}
                <h2 style={{ fontSize: 18, fontWeight: 700, color: "#1a1a1a", marginBottom: 4 }}>
                    Before you reboot
                </h2>

                {/* Device image */}
                <div style={{ textAlign: "center", margin: "20px 0 12px" }}>
                    <div style={{
                        width: 90, height: 90, borderRadius: "50%",
                        backgroundColor: "#e8f0fe",
                        display: "inline-flex", alignItems: "center", justifyContent: "center",
                    }}>
                        <span style={{ fontSize: 44 }}>🔄</span>
                    </div>
                    <div style={{ marginTop: 12, fontSize: 15, fontWeight: 600, color: "#1a1a1a" }}>
                        Device – reboot
                    </div>
                    <div style={{ fontSize: 13, color: "#666", marginTop: 4 }}>
                        Follow the steps below before tapping Proceed
                    </div>
                </div>

                {/* Steps */}
                {[
                    { n: 1, title: "Confirm the device is idle", desc: "Make sure no unlock or lock command is currently in progress before rebooting." },
                    { n: 2, title: "Device will go offline briefly", desc: "The device will disconnect and restart. This usually takes 30–60 seconds." },
                    { n: 3, title: "Wait for reconnection", desc: "Once rebooted, the device will automatically reconnect and its status will update on the dashboard." },
                ].map(({ n, title, desc }) => (
                    <div key={n} style={{ display: "flex", gap: 12, marginBottom: 16, alignItems: "flex-start" }}>
                        <div style={{
                            minWidth: 26, height: 26, borderRadius: "50%",
                            backgroundColor: "#dbeafe", color: "#1d4ed8",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            fontSize: 12, fontWeight: 700, flexShrink: 0,
                        }}>{n}</div>
                        <div>
                            <div style={{ fontSize: 14, fontWeight: 600, color: "#1a1a1a" }}>{title}</div>
                            <div style={{ fontSize: 12, color: "#666", marginTop: 2, lineHeight: 1.5 }}>{desc}</div>
                        </div>
                    </div>
                ))}

                {/* Warning box */}
                <div style={{
                    backgroundColor: "#fff5f5", border: "1px solid #fca5a5",
                    borderRadius: 10, padding: "12px 14px",
                    display: "flex", gap: 10, alignItems: "flex-start",
                    marginBottom: 20,
                }}>
                    <span style={{ fontSize: 18 }}>🔔</span>
                    <span style={{ fontSize: 13, color: "#dc2626", fontWeight: 500, lineHeight: 1.5 }}>
                        Do not attempt to lock or unlock the device while it is rebooting.
                    </span>
                </div>

                {/* Proceed button */}
                <button
                    onClick={()=>  onProceed(lockDataToReboot)}
                    disabled={loading}
                    style={{
                        width: "100%", padding: "14px",
                        backgroundColor: loading ? "#93c5fd" : "#1d4ed8",
                        color: "#fff", border: "none", borderRadius: 10,
                        fontSize: 15, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer",
                        letterSpacing: "0.5px",
                    }}
                >
                    {loading ? "REBOOTING..." : "PROCEED TO REBOOT"}
                </button>
            </div>
        </div>
    );
}

export default LockRebootModal;